<template>

    <m-edit1/>

    <m-single-product-302 v-bind='{...{"productLink":null,"relatedProducts":true,"productCardName":"mProductCard309","relatedCourse":false,"galleryFullSlider":true,"showWhatsAppButtonsMessage":null,"showLastUpdate":false},...{}}' :style='""' class="container" ></m-single-product-302>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleProduct302 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct302';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleProduct302 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
